// FassalkartAI - Admin Protected Route

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingScreen from '../ui/LoadingScreen';

/**
 * Allows access only to users with role === 'admin'.
 */
const AdminRoute = ({ children }) => {
  const { currentUser, userProfile, loading } = useAuth();

  if (loading) return <LoadingScreen message="Verifying admin access..." />;

  if (!currentUser) return <Navigate to="/login" replace />;

  if (userProfile?.role !== 'admin') return <Navigate to="/dashboard" replace />;

  return children;
};

export default AdminRoute;
